/** AUTO-GENERATED FILE — DO NOT EDIT **/
export const tokens = {
  "primitives": {
    "font-Family-Base": "var(--font-Family-Base)",
    "font-Family-Header": "var(--font-Family-Header)",
    "font-Weight-Light": "var(--font-Weight-Light)",
    "font-Weight-Regular": "var(--font-Weight-Regular)",
    "font-Weight-Medium": "var(--font-Weight-Medium)",
    "font-Weight-SemiBold": "var(--font-Weight-SemiBold)",
    "font-Weight-Bold": "var(--font-Weight-Bold)",
    "font-Size-Base-100": "var(--font-Size-Base-100)",
    "font-Size-Base-200": "var(--font-Size-Base-200)",
    "font-Size-Base-300": "var(--font-Size-Base-300)",
    "font-Size-Base-400": "var(--font-Size-Base-400)",
    "font-Size-Base-500": "var(--font-Size-Base-500)",
    "font-Size-Base-600": "var(--font-Size-Base-600)",
    "font-Size-Hero-700": "var(--font-Size-Hero-700)",
    "font-Size-Hero-800": "var(--font-Size-Hero-800)",
    "font-Size-Hero-900": "var(--font-Size-Hero-900)",
    "font-Size-Hero-1000": "var(--font-Size-Hero-1000)",
    "lineHeight-Base-100": "var(--lineHeight-Base-100)",
    "lineHeight-Base-200": "var(--lineHeight-Base-200)",
    "lineHeight-Base-300": "var(--lineHeight-Base-300)",
    "lineHeight-Base-400": "var(--lineHeight-Base-400)",
    "lineHeight-Base-500": "var(--lineHeight-Base-500)",
    "lineHeight-Base-600": "var(--lineHeight-Base-600)",
    "lineHeight-Hero-700": "var(--lineHeight-Hero-700)",
    "lineHeight-Hero-800": "var(--lineHeight-Hero-800)",
    "lineHeight-Hero-900": "var(--lineHeight-Hero-900)",
    "lineHeight-Hero-1000": "var(--lineHeight-Hero-1000)",
    "stroke-Radius-None": "var(--stroke-Radius-None)",
    "stroke-Radius-Small": "var(--stroke-Radius-Small)",
    "stroke-Radius-Medium": "var(--stroke-Radius-Medium)",
    "stroke-Radius-Large": "var(--stroke-Radius-Large)",
    "stroke-Radius-XLarge": "var(--stroke-Radius-XLarge)",
    "stroke-RadiusXxl": "var(--stroke-Radius-xxl)",
    "stroke-Radius-Circular": "var(--stroke-Radius-Circular)",
    "stroke-Width-Thin": "var(--stroke-Width-Thin)",
    "stroke-Width-Thick": "var(--stroke-Width-Thick)",
    "stroke-Width-Thicker": "var(--stroke-Width-Thicker)",
    "stroke-Width-Thickest": "var(--stroke-Width-Thickest)",
    "spacing-Vertical-None": "var(--spacing-Vertical-None)",
    "spacing-Vertical-XXS": "var(--spacing-Vertical-XXS)",
    "spacing-Vertical-XS": "var(--spacing-Vertical-XS)",
    "spacing-Vertical-SNudge": "var(--spacing-Vertical-SNudge)",
    "spacing-Vertical-S": "var(--spacing-Vertical-S)",
    "spacing-Vertical-MNudge": "var(--spacing-Vertical-MNudge)",
    "spacing-Vertical-M": "var(--spacing-Vertical-M)",
    "spacing-Vertical-L": "var(--spacing-Vertical-L)",
    "spacing-Vertical-XL": "var(--spacing-Vertical-XL)",
    "spacing-Vertical-XXL": "var(--spacing-Vertical-XXL)",
    "spacing-Vertical-XXXL": "var(--spacing-Vertical-XXXL)",
    "spacing-Horizontal-None": "var(--spacing-Horizontal-None)",
    "spacing-Horizontal-XXS": "var(--spacing-Horizontal-XXS)",
    "spacing-Horizontal-XS": "var(--spacing-Horizontal-XS)",
    "spacing-Horizontal-SNudge": "var(--spacing-Horizontal-SNudge)",
    "spacing-Horizontal-S": "var(--spacing-Horizontal-S)",
    "spacing-Horizontal-MNudge": "var(--spacing-Horizontal-MNudge)",
    "spacing-Horizontal-M": "var(--spacing-Horizontal-M)",
    "spacing-Horizontal-L": "var(--spacing-Horizontal-L)",
    "spacing-Horizontal-XL": "var(--spacing-Horizontal-XL)",
    "spacing-Horizontal-XXL": "var(--spacing-Horizontal-XXL)",
    "spacing-Horizontal-XXXL": "var(--spacing-Horizontal-XXXL)",
    "strokeDefault": "var(--stroke-default)",
    "strokeSubtle": "var(--stroke-subtle)",
    "strokeStrong": "var(--stroke-strong)",
    "strokeInteractive": "var(--stroke-interactive)",
    "strokeFocus": "var(--stroke-focus)",
    "strokeBrand": "var(--stroke-brand)",
    "strokeDisabled": "var(--stroke-disabled)",
    "spacingXxs": "var(--spacing-xxs)",
    "spacingXs": "var(--spacing-xs)",
    "spacingSm": "var(--spacing-sm)",
    "spacingMd": "var(--spacing-md)",
    "spacingLg": "var(--spacing-lg)",
    "spacingXl": "var(--spacing-xl)",
    "spacingXxl": "var(--spacing-xxl)",
    "spacingXxxl": "var(--spacing-xxxl)",
    "fontFamilyPrimary": "var(--font-family-primary)",
    "fontFamilySecondary": "var(--font-family-secondary)",
    "fontSizeXs": "var(--font-size-xs)",
    "fontSizeSm": "var(--font-size-sm)",
    "fontSizeBase": "var(--font-size-base)",
    "fontSizeMd": "var(--font-size-md)",
    "fontSizeLg": "var(--font-size-lg)",
    "fontSizeXl": "var(--font-size-xl)",
    "fontSizeXxl": "var(--font-size-xxl)",
    "fontSizeXxxl": "var(--font-size-xxxl)",
    "fontSizeDisplay": "var(--font-size-display)",
    "fontWeightLight": "var(--font-weight-light)",
    "fontWeightRegular": "var(--font-weight-regular)",
    "fontWeightMedium": "var(--font-weight-medium)",
    "fontWeightSemibold": "var(--font-weight-semibold)",
    "fontWeightBold": "var(--font-weight-bold)"
  },
  "palette": {
    "theme-Darker": "var(--theme-Darker)",
    "theme-Dark": "var(--theme-Dark)",
    "theme-DarkAlt": "var(--theme-DarkAlt)",
    "theme-Primary": "var(--theme-Primary)",
    "theme-Secondary": "var(--theme-Secondary)",
    "theme-Tertiary": "var(--theme-Tertiary)",
    "theme-Light": "var(--theme-Light)",
    "theme-Lighter": "var(--theme-Lighter)",
    "theme-LighterAlt": "var(--theme-LighterAlt)",
    "accent-Darker": "var(--accent-Darker)",
    "accent-Dark": "var(--accent-Dark)",
    "accent-DarkAlt": "var(--accent-DarkAlt)",
    "accent-Primary": "var(--accent-Primary)",
    "accent-Secondary": "var(--accent-Secondary)",
    "accent-Tertiary": "var(--accent-Tertiary)",
    "accent-Light": "var(--accent-Light)",
    "accent-Lighter": "var(--accent-Lighter)",
    "accent-LighterAlt": "var(--accent-LighterAlt)",
    "semanticTransparent": "var(--semantic-transparent)",
    "semanticDanger-Darkest": "var(--semantic-danger-Darkest)",
    "semanticDanger-Darker": "var(--semantic-danger-Darker)",
    "semanticDanger-Dark": "var(--semantic-danger-Dark)",
    "semanticDanger-Primary": "var(--semantic-danger-Primary)",
    "semanticDanger-Secondary": "var(--semantic-danger-Secondary)",
    "semanticDanger-Tertiary": "var(--semantic-danger-Tertiary)",
    "semanticDanger-Light": "var(--semantic-danger-Light)",
    "semanticDanger-Lighter": "var(--semantic-danger-Lighter)",
    "semanticDanger-Lightest": "var(--semantic-danger-Lightest)",
    "semanticCaution-Darkest": "var(--semantic-caution-Darkest)",
    "semanticCaution-Darker": "var(--semantic-caution-Darker)",
    "semanticCaution-Dark": "var(--semantic-caution-Dark)",
    "semanticCaution-Primary": "var(--semantic-caution-Primary)",
    "semanticCaution-Secondary": "var(--semantic-caution-Secondary)",
    "semanticCaution-Tertiary": "var(--semantic-caution-Tertiary)",
    "semanticCaution-Light": "var(--semantic-caution-Light)",
    "semanticCaution-Lighter": "var(--semantic-caution-Lighter)",
    "semanticCaution-Lightest": "var(--semantic-caution-Lightest)",
    "semanticSuccess-Darkest": "var(--semantic-success-Darkest)",
    "semanticSuccess-Darker": "var(--semantic-success-Darker)",
    "semanticSuccess-Dark": "var(--semantic-success-Dark)",
    "semanticSuccess-Primary": "var(--semantic-success-Primary)",
    "semanticSuccess-Secondary": "var(--semantic-success-Secondary)",
    "semanticSuccess-Tertiary": "var(--semantic-success-Tertiary)",
    "semanticSuccess-Light": "var(--semantic-success-Light)",
    "semanticSuccess-Lighter": "var(--semantic-success-Lighter)",
    "semanticSuccess-Lightest": "var(--semantic-success-Lightest)",
    "semanticInfo-Darkest": "var(--semantic-info-Darkest)",
    "semanticInfo-Darker": "var(--semantic-info-Darker)",
    "semanticInfo-Dark": "var(--semantic-info-Dark)",
    "semanticInfo-Primary": "var(--semantic-info-Primary)",
    "semanticInfo-Secondary": "var(--semantic-info-Secondary)",
    "semanticInfo-Tertiary": "var(--semantic-info-Tertiary)",
    "semanticInfo-Light": "var(--semantic-info-Light)",
    "semanticInfo-Lighter": "var(--semantic-info-Lighter)",
    "semanticInfo-Lightest": "var(--semantic-info-Lightest)"
  },
  "typography": {
    "typography-Title1": "var(--typography--title1)",
    "typography-Title2": "var(--typography--title2)",
    "typography-Title3": "var(--typography--title3)",
    "typography-Title4": "var(--typography--title4)",
    "typography-Subtitle1": "var(--typography--subtitle1)",
    "typography-Subtitle2": "var(--typography--subtitle2)",
    "typography-Subtitle3": "var(--typography--subtitle3)",
    "typography-Body1": "var(--typography--body1)",
    "typography-Body2": "var(--typography--body2)",
    "typography-Caption1": "var(--typography--caption1)",
    "typography-Caption2": "var(--typography--caption2)",
    "typography-Body1-Strong": "var(--typography--body1--strong)",
    "typography-Body1-Stronger": "var(--typography--body1--stronger)",
    "typography-Body2-Strong": "var(--typography--body2--strong)",
    "typography-Body2-Stronger": "var(--typography--body2--stronger)",
    "typography-Caption1-Strong": "var(--typography--caption1--strong)",
    "typography-Caption1-Stronger": "var(--typography--caption1--stronger)",
    "typography-Caption2-Strong": "var(--typography--caption2--strong)",
    "typography-Caption2-Stronger": "var(--typography--caption2--stronger)",
    "sizeTitle1": "var(--size-title1)",
    "sizeTitle2": "var(--size-title2)",
    "sizeTitle3": "var(--size-title3)",
    "sizeTitle4": "var(--size-title4)",
    "sizeSubtitle1": "var(--size-subtitle1)",
    "sizeSubtitle2": "var(--size-subtitle2)",
    "sizeSubtitle3": "var(--size-subtitle3)",
    "sizeBody1": "var(--size-body1)",
    "sizeBody2": "var(--size-body2)",
    "sizeCaption1": "var(--size-caption1)",
    "sizeCaption2": "var(--size-caption2)",
    "lineHeightTitle1": "var(--line-height-title1)",
    "lineHeightTitle2": "var(--line-height-title2)",
    "lineHeightTitle3": "var(--line-height-title3)",
    "lineHeightTitle4": "var(--line-height-title4)",
    "lineHeightSubtitle1": "var(--line-height-subtitle1)",
    "lineHeightSubtitle2": "var(--line-height-subtitle2)",
    "lineHeightSubtitle3": "var(--line-height-subtitle3)",
    "lineHeightBody1": "var(--line-height-body1)",
    "lineHeightBody2": "var(--line-height-body2)",
    "lineHeightCaption1": "var(--line-height-caption1)",
    "lineHeightCaption2": "var(--line-height-caption2)",
    "lineHeightTight": "var(--line-height-tight)",
    "lineHeightBase": "var(--line-height-base)",
    "lineHeightRelaxed": "var(--line-height-relaxed)",
    "lineHeightSm": "var(--line-height-sm)",
    "lineHeightMd": "var(--line-height-md)",
    "lineHeightLg": "var(--line-height-lg)",
    "lineHeightXl": "var(--line-height-xl)"
  },
  "shadows": {
    "shadow-Inset": "var(--shadow--inset)",
    "shadow-Resting-Xs": "var(--shadow--resting--xs)",
    "shadow-Resting-Small": "var(--shadow--resting--small)",
    "shadow-Resting-Medium": "var(--shadow--resting--medium)",
    "shadow-Floating-Small": "var(--shadow--floating--small)",
    "shadow-Floating-Medium": "var(--shadow--floating--medium)",
    "shadow-Floating-Large": "var(--shadow--floating--large)",
    "shadow-Floating-Xl": "var(--shadow--floating--xl)",
    "inset-Small": "var(--inset--small)"
  },
  "fluid": {},
  "semantic": {
    "neutralBlack": "var(--neutral-black)",
    "neutral-Dark": "var(--neutral-Dark)",
    "neutral-Primary": "var(--neutral-Primary)",
    "neutral-PrimaryAlt": "var(--neutral-PrimaryAlt)",
    "neutral-Secondary": "var(--neutral-Secondary)",
    "neutral-SecondaryAlt": "var(--neutral-SecondaryAlt)",
    "neutral-Tertiary": "var(--neutral-Tertiary)",
    "neutral-TertiaryAlt": "var(--neutral-TertiaryAlt)",
    "neutral-Quaternary": "var(--neutral-Quaternary)",
    "neutral-QuaternaryAlt": "var(--neutral-QuaternaryAlt)",
    "neutral-Light": "var(--neutral-Light)",
    "neutral-Lighter": "var(--neutral-Lighter)",
    "neutral-LighterAlt": "var(--neutral-LighterAlt)",
    "neutral-White": "var(--neutral-White)",
    "brandPrimaryForeground": "var(--brand-primary-foreground)",
    "brandPrimaryBackground": "var(--brand-primary-background)",
    "brandPrimaryStroke": "var(--brand-primary-stroke)",
    "brandPrimaryForegroundHover": "var(--brand-primary-foreground-hover)",
    "brandPrimaryForegroundPressed": "var(--brand-primary-foreground-pressed)",
    "brandPrimaryForegroundSelected": "var(--brand-primary-foreground-selected)",
    "brandPrimaryForegroundDisabled": "var(--brand-primary-foreground-disabled)",
    "brandPrimaryBackgroundHover": "var(--brand-primary-background-hover)",
    "brandPrimaryBackgroundPressed": "var(--brand-primary-background-pressed)",
    "brandPrimaryBackgroundSelected": "var(--brand-primary-background-selected)",
    "brandPrimaryBackgroundDisabled": "var(--brand-primary-background-disabled)",
    "brandPrimaryStrokeHover": "var(--brand-primary-stroke-hover)",
    "brandPrimaryStrokePressed": "var(--brand-primary-stroke-pressed)",
    "brandPrimaryStrokeSelected": "var(--brand-primary-stroke-selected)",
    "brandPrimaryStrokeDisabled": "var(--brand-primary-stroke-disabled)",
    "brandSecondaryForeground": "var(--brand-secondary-foreground)",
    "brandSecondaryBackground": "var(--brand-secondary-background)",
    "brandSecondaryStroke": "var(--brand-secondary-stroke)",
    "brandSecondaryForegroundHover": "var(--brand-secondary-foreground-hover)",
    "brandSecondaryForegroundPressed": "var(--brand-secondary-foreground-pressed)",
    "brandSecondaryForegroundSelected": "var(--brand-secondary-foreground-selected)",
    "brandSecondaryBackgroundHover": "var(--brand-secondary-background-hover)",
    "brandSecondaryBackgroundPressed": "var(--brand-secondary-background-pressed)",
    "brandSecondaryBackgroundSelected": "var(--brand-secondary-background-selected)",
    "brandSecondaryStrokeHover": "var(--brand-secondary-stroke-hover)",
    "brandSecondaryStrokePressed": "var(--brand-secondary-stroke-pressed)",
    "brandSecondaryStrokeSelected": "var(--brand-secondary-stroke-selected)",
    "brandSecondaryStrokeDisabled": "var(--brand-secondary-stroke-disabled)",
    "brandAccentPrimaryForeground": "var(--brand-accent-primary-foreground)",
    "brandAccentPrimaryBackground": "var(--brand-accent-primary-background)",
    "brandAccentPrimaryStroke": "var(--brand-accent-primary-stroke)",
    "brandAccentPrimaryForegroundHover": "var(--brand-accent-primary-foreground-hover)",
    "brandAccentPrimaryForegroundPressed": "var(--brand-accent-primary-foreground-pressed)",
    "brandAccentPrimaryForegroundSelected": "var(--brand-accent-primary-foreground-selected)",
    "brandAccentPrimaryBackgroundHover": "var(--brand-accent-primary-background-hover)",
    "brandAccentPrimaryBackgroundPressed": "var(--brand-accent-primary-background-pressed)",
    "brandAccentPrimaryBackgroundSelected": "var(--brand-accent-primary-background-selected)",
    "brandAccentPrimaryStrokeHover": "var(--brand-accent-primary-stroke-hover)",
    "brandAccentPrimaryStrokePressed": "var(--brand-accent-primary-stroke-pressed)",
    "brandAccentPrimaryStrokeSelected": "var(--brand-accent-primary-stroke-selected)",
    "brandAccentPrimaryStrokeDisabled": "var(--brand-accent-primary-stroke-disabled)",
    "brandAccentSecondaryForeground": "var(--brand-accent-secondary-foreground)",
    "brandAccentSecondaryBackground": "var(--brand-accent-secondary-background)",
    "brandAccentSecondaryStroke": "var(--brand-accent-secondary-stroke)",
    "brandAccentSecondaryForegroundHover": "var(--brand-accent-secondary-foreground-hover)",
    "brandAccentSecondaryForegroundPressed": "var(--brand-accent-secondary-foreground-pressed)",
    "brandAccentSecondaryForegroundSelected": "var(--brand-accent-secondary-foreground-selected)",
    "brandAccentSecondaryBackgroundHover": "var(--brand-accent-secondary-background-hover)",
    "brandAccentSecondaryBackgroundPressed": "var(--brand-accent-secondary-background-pressed)",
    "brandAccentSecondaryBackgroundSelected": "var(--brand-accent-secondary-background-selected)",
    "brandAccentSecondaryStrokeHover": "var(--brand-accent-secondary-stroke-hover)",
    "brandAccentSecondaryStrokePressed": "var(--brand-accent-secondary-stroke-pressed)",
    "brandAccentSecondaryStrokeSelected": "var(--brand-accent-secondary-stroke-selected)",
    "brandAccentSecondaryStrokeDisabled": "var(--brand-accent-secondary-stroke-disabled)",
    "neutralPrimaryForeground": "var(--neutral-primary-foreground)",
    "neutralPrimaryBackground": "var(--neutral-primary-background)",
    "neutralPrimaryStroke": "var(--neutral-primary-stroke)",
    "neutralPrimaryForegroundHover": "var(--neutral-primary-foreground-hover)",
    "neutralPrimaryForegroundPressed": "var(--neutral-primary-foreground-pressed)",
    "neutralPrimaryForegroundSelected": "var(--neutral-primary-foreground-selected)",
    "neutralPrimaryForegroundDisabled": "var(--neutral-primary-foreground-disabled)",
    "neutralPrimaryForegroundDisabled-2": "var(--neutral-primary-foreground-disabled-2)",
    "neutralPrimaryBackgroundHover": "var(--neutral-primary-background-hover)",
    "neutralPrimaryBackgroundPressed": "var(--neutral-primary-background-pressed)",
    "neutralPrimaryBackgroundSelected": "var(--neutral-primary-background-selected)",
    "neutralPrimaryBackgroundDisabled": "var(--neutral-primary-background-disabled)",
    "neutralPrimaryStrokeHover": "var(--neutral-primary-stroke-hover)",
    "neutralPrimaryStrokePressed": "var(--neutral-primary-stroke-pressed)",
    "neutralPrimaryStrokeSelected": "var(--neutral-primary-stroke-selected)",
    "neutralPrimaryStrokeDisabled": "var(--neutral-primary-stroke-disabled)",
    "neutralSecondaryForeground": "var(--neutral-secondary-foreground)",
    "neutralSecondaryBackground": "var(--neutral-secondary-background)",
    "neutralSecondaryStroke": "var(--neutral-secondary-stroke)",
    "neutralSecondaryForegroundHover": "var(--neutral-secondary-foreground-hover)",
    "neutralSecondaryForegroundPressed": "var(--neutral-secondary-foreground-pressed)",
    "neutralSecondaryForegroundSelected": "var(--neutral-secondary-foreground-selected)",
    "neutralSecondaryForegroundDisabled": "var(--neutral-secondary-foreground-disabled)",
    "neutralSecondaryBackgroundHover": "var(--neutral-secondary-background-hover)",
    "neutralSecondaryBackgroundPressed": "var(--neutral-secondary-background-pressed)",
    "neutralSecondaryBackgroundSelected": "var(--neutral-secondary-background-selected)",
    "neutralSecondaryBackgroundDisabled": "var(--neutral-secondary-background-disabled)",
    "neutralSecondaryStrokeHover": "var(--neutral-secondary-stroke-hover)",
    "neutralSecondaryStrokePressed": "var(--neutral-secondary-stroke-pressed)",
    "neutralSecondaryStrokeSelected": "var(--neutral-secondary-stroke-selected)",
    "neutralSecondaryStrokeDisabled": "var(--neutral-secondary-stroke-disabled)",
    "neutralTertiaryForeground": "var(--neutral-tertiary-foreground)",
    "neutralTertiaryBackground": "var(--neutral-tertiary-background)",
    "neutralTertiaryStroke": "var(--neutral-tertiary-stroke)",
    "neutralTertiaryForegroundHover": "var(--neutral-tertiary-foreground-hover)",
    "neutralTertiaryForegroundPressed": "var(--neutral-tertiary-foreground-pressed)",
    "neutralTertiaryForegroundSelected": "var(--neutral-tertiary-foreground-selected)",
    "neutralTertiaryForegroundDisabled": "var(--neutral-tertiary-foreground-disabled)",
    "neutralTertiaryBackgroundHover": "var(--neutral-tertiary-background-hover)",
    "neutralTertiaryBackgroundPressed": "var(--neutral-tertiary-background-pressed)",
    "neutralTertiaryBackgroundSelected": "var(--neutral-tertiary-background-selected)",
    "neutralTertiaryBackgroundDisabled": "var(--neutral-tertiary-background-disabled)",
    "neutralTertiaryStrokeHover": "var(--neutral-tertiary-stroke-hover)",
    "neutralTertiaryStrokePressed": "var(--neutral-tertiary-stroke-pressed)",
    "neutralTertiaryStrokeSelected": "var(--neutral-tertiary-stroke-selected)",
    "neutralTertiaryStrokeDisabled": "var(--neutral-tertiary-stroke-disabled)",
    "neutralInverse": "var(--neutral-inverse)",
    "neutralPlaceholder": "var(--neutral-placeholder)",
    "neutralOverlay": "var(--neutral-overlay)",
    "neutralLinkForeground": "var(--neutral-link-foreground)",
    "neutralLinkForegroundHover": "var(--neutral-link-foreground-hover)",
    "neutralLinkForegroundPressed": "var(--neutral-link-foreground-pressed)",
    "neutralLinkForegroundSelected": "var(--neutral-link-foreground-selected)",
    "statusSuccess": "var(--status-success)",
    "statusSuccessForegroundPrimary": "var(--status-success-foreground-primary)",
    "statusSuccessForegroundSecondary": "var(--status-success-foreground-secondary)",
    "statusSuccessForegroundPrimaryHover": "var(--status-success-foreground-primary-hover)",
    "statusSuccessForegroundPrimaryPressed": "var(--status-success-foreground-primary-pressed)",
    "statusSuccessForegroundSecondaryHover": "var(--status-success-foreground-secondary-hover)",
    "statusSuccessForegroundSecondaryPressed": "var(--status-success-foreground-secondary-pressed)",
    "statusSuccessBackgroundPrimary": "var(--status-success-background-primary)",
    "statusSuccessBackgroundPrimaryHover": "var(--status-success-background-primary-hover)",
    "statusSuccessBackgroundPrimaryPressed": "var(--status-success-background-primary-pressed)",
    "statusSuccessBackgroundSecondary": "var(--status-success-background-secondary)",
    "statusSuccessBackgroundSecondaryHover": "var(--status-success-background-secondary-hover)",
    "statusSuccessBackgroundSecondaryPressed": "var(--status-success-background-secondary-pressed)",
    "statusSuccessStrokePrimary": "var(--status-success-stroke-primary)",
    "statusSuccessStrokeSecondary": "var(--status-success-stroke-secondary)",
    "statusSuccessStrokePrimaryHover": "var(--status-success-stroke-primary-hover)",
    "statusSuccessStrokePrimaryPressed": "var(--status-success-stroke-primary-pressed)",
    "statusSuccessStrokeSecondaryHover": "var(--status-success-stroke-secondary-hover)",
    "statusSuccessStrokeSecondaryPressed": "var(--status-success-stroke-secondary-pressed)",
    "statusWarning": "var(--status-warning)",
    "statusError": "var(--status-error)",
    "statusDangerForegroundPrimary": "var(--status-danger-foreground-primary)",
    "statusDangerForegroundSecondary": "var(--status-danger-foreground-secondary)",
    "statusDangerForegroundPrimaryHover": "var(--status-danger-foreground-primary-hover)",
    "statusDangerForegroundPrimaryPressed": "var(--status-danger-foreground-primary-pressed)",
    "statusDangerForegroundSecondaryHover": "var(--status-danger-foreground-secondary-hover)",
    "statusDangerForegroundSecondaryPressed": "var(--status-danger-foreground-secondary-pressed)",
    "statusDangerBackgroundPrimary": "var(--status-danger-background-primary)",
    "statusDangerBackgroundPrimaryHover": "var(--status-danger-background-primary-hover)",
    "statusDangerBackgroundPrimaryPressed": "var(--status-danger-background-primary-pressed)",
    "statusDangerBackgroundSecondary": "var(--status-danger-background-secondary)",
    "statusDangerBackgroundSecondaryHover": "var(--status-danger-background-secondary-hover)",
    "statusDangerBackgroundSecondaryPressed": "var(--status-danger-background-secondary-pressed)",
    "statusDangerStrokePrimary": "var(--status-danger-stroke-primary)",
    "statusDangerStrokeSecondary": "var(--status-danger-stroke-secondary)",
    "statusDangerStrokePrimaryHover": "var(--status-danger-stroke-primary-hover)",
    "statusDangerStrokePrimaryPressed": "var(--status-danger-stroke-primary-pressed)",
    "statusDangerStrokeSecondaryHover": "var(--status-danger-stroke-secondary-hover)",
    "statusDangerStrokeSecondaryPressed": "var(--status-danger-stroke-secondary-pressed)",
    "statusInfo": "var(--status-info)",
    "statusNeutral": "var(--status-neutral)"
  },
  "components": {
    "navWidthCollapsed": "var(--nav-width-collapsed)",
    "navWidthExpanded": "var(--nav-width-expanded)",
    "navBackground": "var(--nav-background)",
    "navForeground": "var(--nav-foreground)",
    "navForegroundMuted": "var(--nav-foreground-muted)",
    "navForegroundHover": "var(--nav-foreground-hover)",
    "navItemBackground": "var(--nav-item-background)",
    "navItemBackgroundHover": "var(--nav-item-background-hover)",
    "navItemBackgroundPressed": "var(--nav-item-background-pressed)",
    "navItemBackgroundSelected": "var(--nav-item-background-selected)",
    "navItemForeground": "var(--nav-item-foreground)",
    "navItemForegroundHover": "var(--nav-item-foreground-hover)",
    "navItemForegroundSelected": "var(--nav-item-foreground-selected)",
    "navBorderSubtle": "var(--nav-border-subtle)",
    "navBorderRadius": "var(--nav-border-radius)",
    "navPaddingHorizontal": "var(--nav-padding-horizontal)",
    "navPaddingVertical": "var(--nav-padding-vertical)",
    "navItemGap": "var(--nav-item-gap)",
    "navSectionMarginTop": "var(--nav-section-margin-top)",
    "headerBackground": "var(--header-background)",
    "cardForeground": "var(--card-foreground)",
    "cardBackground": "var(--card-background)",
    "cardForegroundHover": "var(--card-foreground-hover)",
    "cardForegroundPressed": "var(--card-foreground-pressed)",
    "cardForegroundSelected": "var(--card-foreground-selected)",
    "cardBackgroundHover": "var(--card-background-hover)",
    "cardBackgroundPressed": "var(--card-background-pressed)",
    "cardBackgroundSelected": "var(--card-background-selected)",
    "cardBorder": "var(--card-border)",
    "cardBorderHover": "var(--card-border-hover)",
    "cardBorderPressed": "var(--card-border-pressed)",
    "cardBorderSelected": "var(--card-border-selected)",
    "cardPadding": "var(--card-padding)",
    "messageUserForeground": "var(--message-user-foreground)",
    "messageUserBackground": "var(--message-user-background)",
    "messageUserBorder": "var(--message-user-border)",
    "messageBotForeground": "var(--message-bot-foreground)",
    "messageBotBackground": "var(--message-bot-background)",
    "messageBotBorder": "var(--message-bot-border)",
    "messageErrorForeground": "var(--message-error-foreground)",
    "messageErrorBackground": "var(--message-error-background)",
    "messageErrorBorder": "var(--message-error-border)",
    "messageCitationForeground": "var(--message-citation-foreground)",
    "messageCitationBackground": "var(--message-citation-background)",
    "messageCitationStroke": "var(--message-citation-stroke)",
    "messageCitationHoverForeground": "var(--message-citation-hover-foreground)",
    "messageCitationHoverBackground": "var(--message-citation-hover-background)",
    "messageCitationHoverStroke": "var(--message-citation-hover-stroke)",
    "messageCitationPressedForeground": "var(--message-citation-pressed-foreground)",
    "messageCitationPressedBackground": "var(--message-citation-pressed-background)",
    "messageCitationPressedStroke": "var(--message-citation-pressed-stroke)",
    "messageFollowUpForeground": "var(--message-follow-up-foreground)",
    "messageFollowUpBackground": "var(--message-follow-up-background)",
    "messageFollowUpStroke": "var(--message-follow-up-stroke)",
    "messageFollowUpHoverForeground": "var(--message-follow-up-hover-foreground)",
    "messageFollowUpHoverBackground": "var(--message-follow-up-hover-background)",
    "messageFollowUpHoverStroke": "var(--message-follow-up-hover-stroke)",
    "messageFollowUpPressedForeground": "var(--message-follow-up-pressed-foreground)",
    "messageFollowUpPressedBackground": "var(--message-follow-up-pressed-background)",
    "messageFollowUpPressedStroke": "var(--message-follow-up-pressed-stroke)",
    "inputForeground": "var(--input-foreground)",
    "inputForegroundHover": "var(--input-foreground-hover)",
    "inputForegroundPressed": "var(--input-foreground-pressed)",
    "inputForegroundSelected": "var(--input-foreground-selected)",
    "inputForegroundDisabled": "var(--input-foreground-disabled)",
    "inputBackground": "var(--input-background)",
    "inputBackgroundHover": "var(--input-background-hover)",
    "inputBackgroundPressed": "var(--input-background-pressed)",
    "inputBackgroundSelected": "var(--input-background-selected)",
    "inputBackgroundDisabled": "var(--input-background-disabled)",
    "inputStroke": "var(--input-stroke)",
    "inputStrokeHover": "var(--input-stroke-hover)",
    "inputStrokePressed": "var(--input-stroke-pressed)",
    "inputStrokeSelected": "var(--input-stroke-selected)",
    "inputStrokeDisabled": "var(--input-stroke-disabled)",
    "inputHeight": "var(--input-height)",
    "dialogForeground": "var(--dialog-foreground)",
    "dialogBackground": "var(--dialog-background)",
    "dialogStroke": "var(--dialog-stroke)",
    "dialogRadius": "var(--dialog-radius)",
    "avatarUserForeground": "var(--avatar-user-foreground)",
    "avatarUserBackground": "var(--avatar-user-background)",
    "avatarUserBorder": "var(--avatar-user-border)",
    "avatarBotForeground": "var(--avatar-bot-foreground)",
    "avatarBotBackground": "var(--avatar-bot-background)",
    "avatarBotBorder": "var(--avatar-bot-border)",
    "avatarErrorForeground": "var(--avatar-error-foreground)",
    "avatarErrorBackground": "var(--avatar-error-background)",
    "avatarErrorBorder": "var(--avatar-error-border)",
    "chatMaxWidth": "var(--chat-max-width)",
    "chatGptMaxWidth": "var(--chat-gpt-max-width)",
    "exampleHeight": "var(--example-height)",
    "exampleWidth": "var(--example-width)",
    "iconSizeSm": "var(--icon-size-sm)",
    "iconSizeMd": "var(--icon-size-md)",
    "iconSizeLg": "var(--icon-size-lg)"
  },
  "buttons": {
    "buttonSolidPrimaryForeground": "var(--button-solid-primary-foreground)",
    "buttonSolidPrimaryBackground": "var(--button-solid-primary-background)",
    "buttonSolidPrimaryStroke": "var(--button-solid-primary-stroke)",
    "buttonSolidPrimaryForegroundHover": "var(--button-solid-primary-foreground-hover)",
    "buttonSolidPrimaryForegroundPressed": "var(--button-solid-primary-foreground-pressed)",
    "buttonSolidPrimaryForegroundSelected": "var(--button-solid-primary-foreground-selected)",
    "buttonSolidPrimaryForegroundDisabled": "var(--button-solid-primary-foreground-disabled)",
    "buttonSolidPrimaryBackgroundHover": "var(--button-solid-primary-background-hover)",
    "buttonSolidPrimaryBackgroundPressed": "var(--button-solid-primary-background-pressed)",
    "buttonSolidPrimaryBackgroundSelected": "var(--button-solid-primary-background-selected)",
    "buttonSolidPrimaryBackgroundDisabled": "var(--button-solid-primary-background-disabled)",
    "buttonSolidPrimaryStrokeHover": "var(--button-solid-primary-stroke-hover)",
    "buttonSolidPrimaryStrokePressed": "var(--button-solid-primary-stroke-pressed)",
    "buttonSolidPrimaryStrokeSelected": "var(--button-solid-primary-stroke-selected)",
    "buttonSolidPrimaryStrokeDisabled": "var(--button-solid-primary-stroke-disabled)",
    "buttonSolidPrimaryInverseForeground": "var(--button-solid-primary-inverse-foreground)",
    "buttonSolidPrimaryInverseBackground": "var(--button-solid-primary-inverse-background)",
    "buttonSolidPrimaryInverseStroke": "var(--button-solid-primary-inverse-stroke)",
    "buttonSolidPrimaryInverseForegroundHover": "var(--button-solid-primary-inverse-foreground-hover)",
    "buttonSolidPrimaryInverseForegroundPressed": "var(--button-solid-primary-inverse-foreground-pressed)",
    "buttonSolidPrimaryInverseForegroundSelected": "var(--button-solid-primary-inverse-foreground-selected)",
    "buttonSolidPrimaryInverseForegroundDisabled": "var(--button-solid-primary-inverse-foreground-disabled)",
    "buttonSolidPrimaryInverseBackgroundHover": "var(--button-solid-primary-inverse-background-hover)",
    "buttonSolidPrimaryInverseBackgroundPressed": "var(--button-solid-primary-inverse-background-pressed)",
    "buttonSolidPrimaryInverseBackgroundSelected": "var(--button-solid-primary-inverse-background-selected)",
    "buttonSolidPrimaryInverseBackgroundDisabled": "var(--button-solid-primary-inverse-background-disabled)",
    "buttonSolidPrimaryInverseStrokeHover": "var(--button-solid-primary-inverse-stroke-hover)",
    "buttonSolidPrimaryInverseStrokePressed": "var(--button-solid-primary-inverse-stroke-pressed)",
    "buttonSolidPrimaryInverseStrokeSelected": "var(--button-solid-primary-inverse-stroke-selected)",
    "buttonSolidPrimaryInverseStrokeDisabled": "var(--button-solid-primary-inverse-stroke-disabled)",
    "buttonSolidSecondaryForeground": "var(--button-solid-secondary-foreground)",
    "buttonSolidSecondaryBackground": "var(--button-solid-secondary-background)",
    "buttonSolidSecondaryStroke": "var(--button-solid-secondary-stroke)",
    "buttonSolidSecondaryForegroundHover": "var(--button-solid-secondary-foreground-hover)",
    "buttonSolidSecondaryForegroundPressed": "var(--button-solid-secondary-foreground-pressed)",
    "buttonSolidSecondaryForegroundSelected": "var(--button-solid-secondary-foreground-selected)",
    "buttonSolidSecondaryForegroundDisabled": "var(--button-solid-secondary-foreground-disabled)",
    "buttonSolidSecondaryBackgroundHover": "var(--button-solid-secondary-background-hover)",
    "buttonSolidSecondaryBackgroundPressed": "var(--button-solid-secondary-background-pressed)",
    "buttonSolidSecondaryBackgroundSelected": "var(--button-solid-secondary-background-selected)",
    "buttonSolidSecondaryBackgroundDisabled": "var(--button-solid-secondary-background-disabled)",
    "buttonSolidSecondaryStrokeHover": "var(--button-solid-secondary-stroke-hover)",
    "buttonSolidSecondaryStrokePressed": "var(--button-solid-secondary-stroke-pressed)",
    "buttonSolidSecondaryStrokeSelected": "var(--button-solid-secondary-stroke-selected)",
    "buttonSolidSecondaryStrokeDisabled": "var(--button-solid-secondary-stroke-disabled)",
    "buttonSolidSecondaryInverseForeground": "var(--button-solid-secondary-inverse-foreground)",
    "buttonSolidSecondaryInverseBackground": "var(--button-solid-secondary-inverse-background)",
    "buttonSolidSecondaryInverseStroke": "var(--button-solid-secondary-inverse-stroke)",
    "buttonSolidSecondaryInverseForegroundHover": "var(--button-solid-secondary-inverse-foreground-hover)",
    "buttonSolidSecondaryInverseForegroundPressed": "var(--button-solid-secondary-inverse-foreground-pressed)",
    "buttonSolidSecondaryInverseForegroundSelected": "var(--button-solid-secondary-inverse-foreground-selected)",
    "buttonSolidSecondaryInverseForegroundDisabled": "var(--button-solid-secondary-inverse-foreground-disabled)",
    "buttonSolidSecondaryInverseBackgroundHover": "var(--button-solid-secondary-inverse-background-hover)",
    "buttonSolidSecondaryInverseBackgroundPressed": "var(--button-solid-secondary-inverse-background-pressed)",
    "buttonSolidSecondaryInverseBackgroundSelected": "var(--button-solid-secondary-inverse-background-selected)",
    "buttonSolidSecondaryInverseBackgroundDisabled": "var(--button-solid-secondary-inverse-background-disabled)",
    "buttonSolidSecondaryInverseStrokeHover": "var(--button-solid-secondary-inverse-stroke-hover)",
    "buttonSolidSecondaryInverseStrokePressed": "var(--button-solid-secondary-inverse-stroke-pressed)",
    "buttonSolidSecondaryInverseStrokeSelected": "var(--button-solid-secondary-inverse-stroke-selected)",
    "buttonSolidSecondaryInverseStrokeDisabled": "var(--button-solid-secondary-inverse-stroke-disabled)",
    "buttonOutlinedPrimaryForeground": "var(--button-outlined-primary-foreground)",
    "buttonOutlinedPrimaryBackground": "var(--button-outlined-primary-background)",
    "buttonOutlinedPrimaryStroke": "var(--button-outlined-primary-stroke)",
    "buttonOutlinedPrimaryForegroundHover": "var(--button-outlined-primary-foreground-hover)",
    "buttonOutlinedPrimaryForegroundPressed": "var(--button-outlined-primary-foreground-pressed)",
    "buttonOutlinedPrimaryForegroundSelected": "var(--button-outlined-primary-foreground-selected)",
    "buttonOutlinedPrimaryForegroundDisabled": "var(--button-outlined-primary-foreground-disabled)",
    "buttonOutlinedPrimaryBackgroundHover": "var(--button-outlined-primary-background-hover)",
    "buttonOutlinedPrimaryBackgroundPressed": "var(--button-outlined-primary-background-pressed)",
    "buttonOutlinedPrimaryBackgroundSelected": "var(--button-outlined-primary-background-selected)",
    "buttonOutlinedPrimaryBackgroundDisabled": "var(--button-outlined-primary-background-disabled)",
    "buttonOutlinedPrimaryStrokeHover": "var(--button-outlined-primary-stroke-hover)",
    "buttonOutlinedPrimaryStrokePressed": "var(--button-outlined-primary-stroke-pressed)",
    "buttonOutlinedPrimaryStrokeSelected": "var(--button-outlined-primary-stroke-selected)",
    "buttonOutlinedPrimaryStrokeDisabled": "var(--button-outlined-primary-stroke-disabled)",
    "buttonOutlinedPrimaryInverseForeground": "var(--button-outlined-primary-inverse-foreground)",
    "buttonOutlinedPrimaryInverseBackground": "var(--button-outlined-primary-inverse-background)",
    "buttonOutlinedPrimaryInverseStroke": "var(--button-outlined-primary-inverse-stroke)",
    "buttonOutlinedPrimaryInverseForegroundHover": "var(--button-outlined-primary-inverse-foreground-hover)",
    "buttonOutlinedPrimaryInverseForegroundPressed": "var(--button-outlined-primary-inverse-foreground-pressed)",
    "buttonOutlinedPrimaryInverseForegroundSelected": "var(--button-outlined-primary-inverse-foreground-selected)",
    "buttonOutlinedPrimaryInverseForegroundDisabled": "var(--button-outlined-primary-inverse-foreground-disabled)",
    "buttonOutlinedPrimaryInverseBackgroundHover": "var(--button-outlined-primary-inverse-background-hover)",
    "buttonOutlinedPrimaryInverseBackgroundPressed": "var(--button-outlined-primary-inverse-background-pressed)",
    "buttonOutlinedPrimaryInverseBackgroundSelected": "var(--button-outlined-primary-inverse-background-selected)",
    "buttonOutlinedPrimaryInverseBackgroundDisabled": "var(--button-outlined-primary-inverse-background-disabled)",
    "buttonOutlinedPrimaryInverseStrokeHover": "var(--button-outlined-primary-inverse-stroke-hover)",
    "buttonOutlinedPrimaryInverseStrokePressed": "var(--button-outlined-primary-inverse-stroke-pressed)",
    "buttonOutlinedPrimaryInverseStrokeSelected": "var(--button-outlined-primary-inverse-stroke-selected)",
    "buttonOutlinedPrimaryInverseStrokeDisabled": "var(--button-outlined-primary-inverse-stroke-disabled)",
    "buttonOutlinedSecondaryForeground": "var(--button-outlined-secondary-foreground)",
    "buttonOutlinedSecondaryBackground": "var(--button-outlined-secondary-background)",
    "buttonOutlinedSecondaryStroke": "var(--button-outlined-secondary-stroke)",
    "buttonOutlinedSecondaryForegroundHover": "var(--button-outlined-secondary-foreground-hover)",
    "buttonOutlinedSecondaryForegroundPressed": "var(--button-outlined-secondary-foreground-pressed)",
    "buttonOutlinedSecondaryForegroundSelected": "var(--button-outlined-secondary-foreground-selected)",
    "buttonOutlinedSecondaryForegroundDisabled": "var(--button-outlined-secondary-foreground-disabled)",
    "buttonOutlinedSecondaryBackgroundHover": "var(--button-outlined-secondary-background-hover)",
    "buttonOutlinedSecondaryBackgroundPressed": "var(--button-outlined-secondary-background-pressed)",
    "buttonOutlinedSecondaryBackgroundSelected": "var(--button-outlined-secondary-background-selected)",
    "buttonOutlinedSecondaryBackgroundDisabled": "var(--button-outlined-secondary-background-disabled)",
    "buttonOutlinedSecondaryStrokeHover": "var(--button-outlined-secondary-stroke-hover)",
    "buttonOutlinedSecondaryStrokePressed": "var(--button-outlined-secondary-stroke-pressed)",
    "buttonOutlinedSecondaryStrokeSelected": "var(--button-outlined-secondary-stroke-selected)",
    "buttonOutlinedSecondaryStrokeDisabled": "var(--button-outlined-secondary-stroke-disabled)",
    "buttonOutlinedSecondaryInverseForeground": "var(--button-outlined-secondary-inverse-foreground)",
    "buttonOutlinedSecondaryInverseBackground": "var(--button-outlined-secondary-inverse-background)",
    "buttonOutlinedSecondaryInverseStroke": "var(--button-outlined-secondary-inverse-stroke)",
    "buttonOutlinedSecondaryInverseForegroundHover": "var(--button-outlined-secondary-inverse-foreground-hover)",
    "buttonOutlinedSecondaryInverseForegroundPressed": "var(--button-outlined-secondary-inverse-foreground-pressed)",
    "buttonOutlinedSecondaryInverseForegroundSelected": "var(--button-outlined-secondary-inverse-foreground-selected)",
    "buttonOutlinedSecondaryInverseForegroundDisabled": "var(--button-outlined-secondary-inverse-foreground-disabled)",
    "buttonOutlinedSecondaryInverseBackgroundHover": "var(--button-outlined-secondary-inverse-background-hover)",
    "buttonOutlinedSecondaryInverseBackgroundPressed": "var(--button-outlined-secondary-inverse-background-pressed)",
    "buttonOutlinedSecondaryInverseBackgroundSelected": "var(--button-outlined-secondary-inverse-background-selected)",
    "buttonOutlinedSecondaryInverseBackgroundDisabled": "var(--button-outlined-secondary-inverse-background-disabled)",
    "buttonOutlinedSecondaryInverseStrokeHover": "var(--button-outlined-secondary-inverse-stroke-hover)",
    "buttonOutlinedSecondaryInverseStrokePressed": "var(--button-outlined-secondary-inverse-stroke-pressed)",
    "buttonOutlinedSecondaryInverseStrokeSelected": "var(--button-outlined-secondary-inverse-stroke-selected)",
    "buttonOutlinedSecondaryInverseStrokeDisabled": "var(--button-outlined-secondary-inverse-stroke-disabled)",
    "buttonSubtlePrimaryForeground": "var(--button-subtle-primary-foreground)",
    "buttonSubtlePrimaryBackground": "var(--button-subtle-primary-background)",
    "buttonSubtlePrimaryStroke": "var(--button-subtle-primary-stroke)",
    "buttonSubtlePrimaryForegroundHover": "var(--button-subtle-primary-foreground-hover)",
    "buttonSubtlePrimaryForegroundPressed": "var(--button-subtle-primary-foreground-pressed)",
    "buttonSubtlePrimaryForegroundSelected": "var(--button-subtle-primary-foreground-selected)",
    "buttonSubtlePrimaryForegroundDisabled": "var(--button-subtle-primary-foreground-disabled)",
    "buttonSubtlePrimaryBackgroundHover": "var(--button-subtle-primary-background-hover)",
    "buttonSubtlePrimaryBackgroundPressed": "var(--button-subtle-primary-background-pressed)",
    "buttonSubtlePrimaryBackgroundSelected": "var(--button-subtle-primary-background-selected)",
    "buttonSubtlePrimaryBackgroundDisabled": "var(--button-subtle-primary-background-disabled)",
    "buttonSubtlePrimaryStrokeHover": "var(--button-subtle-primary-stroke-hover)",
    "buttonSubtlePrimaryStrokePressed": "var(--button-subtle-primary-stroke-pressed)",
    "buttonSubtlePrimaryStrokeSelected": "var(--button-subtle-primary-stroke-selected)",
    "buttonSubtlePrimaryStrokeDisabled": "var(--button-subtle-primary-stroke-disabled)",
    "buttonSubtlePrimaryInverseForeground": "var(--button-subtle-primary-inverse-foreground)",
    "buttonSubtlePrimaryInverseBackground": "var(--button-subtle-primary-inverse-background)",
    "buttonSubtlePrimaryInverseStroke": "var(--button-subtle-primary-inverse-stroke)",
    "buttonSubtlePrimaryInverseForegroundHover": "var(--button-subtle-primary-inverse-foreground-hover)",
    "buttonSubtlePrimaryInverseForegroundPressed": "var(--button-subtle-primary-inverse-foreground-pressed)",
    "buttonSubtlePrimaryInverseForegroundSelected": "var(--button-subtle-primary-inverse-foreground-selected)",
    "buttonSubtlePrimaryInverseForegroundDisabled": "var(--button-subtle-primary-inverse-foreground-disabled)",
    "buttonSubtlePrimaryInverseBackgroundHover": "var(--button-subtle-primary-inverse-background-hover)",
    "buttonSubtlePrimaryInverseBackgroundPressed": "var(--button-subtle-primary-inverse-background-pressed)",
    "buttonSubtlePrimaryInverseBackgroundSelected": "var(--button-subtle-primary-inverse-background-selected)",
    "buttonSubtlePrimaryInverseBackgroundDisabled": "var(--button-subtle-primary-inverse-background-disabled)",
    "buttonSubtlePrimaryInverseStrokeHover": "var(--button-subtle-primary-inverse-stroke-hover)",
    "buttonSubtlePrimaryInverseStrokePressed": "var(--button-subtle-primary-inverse-stroke-pressed)",
    "buttonSubtlePrimaryInverseStrokeSelected": "var(--button-subtle-primary-inverse-stroke-selected)",
    "buttonSubtlePrimaryInverseStrokeDisabled": "var(--button-subtle-primary-inverse-stroke-disabled)",
    "buttonSubtleSecondaryForeground": "var(--button-subtle-secondary-foreground)",
    "buttonSubtleSecondaryBackground": "var(--button-subtle-secondary-background)",
    "buttonSubtleSecondaryStroke": "var(--button-subtle-secondary-stroke)",
    "buttonSubtleSecondaryForegroundHover": "var(--button-subtle-secondary-foreground-hover)",
    "buttonSubtleSecondaryForegroundPressed": "var(--button-subtle-secondary-foreground-pressed)",
    "buttonSubtleSecondaryForegroundSelected": "var(--button-subtle-secondary-foreground-selected)",
    "buttonSubtleSecondaryForegroundDisabled": "var(--button-subtle-secondary-foreground-disabled)",
    "buttonSubtleSecondaryBackgroundHover": "var(--button-subtle-secondary-background-hover)",
    "buttonSubtleSecondaryBackgroundPressed": "var(--button-subtle-secondary-background-pressed)",
    "buttonSubtleSecondaryBackgroundSelected": "var(--button-subtle-secondary-background-selected)",
    "buttonSubtleSecondaryBackgroundDisabled": "var(--button-subtle-secondary-background-disabled)",
    "buttonSubtleSecondaryStrokeHover": "var(--button-subtle-secondary-stroke-hover)",
    "buttonSubtleSecondaryStrokePressed": "var(--button-subtle-secondary-stroke-pressed)",
    "buttonSubtleSecondaryStrokeSelected": "var(--button-subtle-secondary-stroke-selected)",
    "buttonSubtleSecondaryStrokeDisabled": "var(--button-subtle-secondary-stroke-disabled)",
    "buttonSubtleSecondaryInverseForeground": "var(--button-subtle-secondary-inverse-foreground)",
    "buttonSubtleSecondaryInverseBackground": "var(--button-subtle-secondary-inverse-background)",
    "buttonSubtleSecondaryInverseStroke": "var(--button-subtle-secondary-inverse-stroke)",
    "buttonSubtleSecondaryInverseForegroundHover": "var(--button-subtle-secondary-inverse-foreground-hover)",
    "buttonSubtleSecondaryInverseForegroundPressed": "var(--button-subtle-secondary-inverse-foreground-pressed)",
    "buttonSubtleSecondaryInverseForegroundSelected": "var(--button-subtle-secondary-inverse-foreground-selected)",
    "buttonSubtleSecondaryInverseForegroundDisabled": "var(--button-subtle-secondary-inverse-foreground-disabled)",
    "buttonSubtleSecondaryInverseBackgroundHover": "var(--button-subtle-secondary-inverse-background-hover)",
    "buttonSubtleSecondaryInverseBackgroundPressed": "var(--button-subtle-secondary-inverse-background-pressed)",
    "buttonSubtleSecondaryInverseBackgroundSelected": "var(--button-subtle-secondary-inverse-background-selected)",
    "buttonSubtleSecondaryInverseBackgroundDisabled": "var(--button-subtle-secondary-inverse-background-disabled)",
    "buttonSubtleSecondaryInverseStrokeHover": "var(--button-subtle-secondary-inverse-stroke-hover)",
    "buttonSubtleSecondaryInverseStrokePressed": "var(--button-subtle-secondary-inverse-stroke-pressed)",
    "buttonSubtleSecondaryInverseStrokeSelected": "var(--button-subtle-secondary-inverse-stroke-selected)",
    "buttonSubtleSecondaryInverseStrokeDisabled": "var(--button-subtle-secondary-inverse-stroke-disabled)"
  },
  "legacy": {
    "colorBrandPrimary": "var(--color-brand-primary)",
    "colorBrandPrimaryHover": "var(--color-brand-primary-hover)",
    "colorBrandPrimaryLight": "var(--color-brand-primary-light)",
    "colorBrandPrimaryMuted": "var(--color-brand-primary-muted)",
    "colorBrandAccent": "var(--color-brand-accent)",
    "colorBrandAccentLight": "var(--color-brand-accent-light)",
    "colorBgPrimary": "var(--color-bg-primary)",
    "colorBgSecondary": "var(--color-bg-secondary)",
    "colorBgTertiary": "var(--color-bg-tertiary)",
    "colorBgInput": "var(--color-bg-input)",
    "colorBgCard": "var(--color-bg-card)",
    "colorBgOverlay": "var(--color-bg-overlay)",
    "colorTextPrimary": "var(--color-text-primary)",
    "colorTextSecondary": "var(--color-text-secondary)",
    "colorTextMuted": "var(--color-text-muted)",
    "colorTextMutedTransparent": "var(--color-text-muted-transparent)",
    "colorTextInverse": "var(--color-text-inverse)",
    "colorTextLink": "var(--color-text-link)",
    "colorBorderDefault": "var(--color-border-default)",
    "colorBorderAccent": "var(--color-border-accent)",
    "colorBorderAccentLight": "var(--color-border-accent-light)",
    "colorBorderFocus": "var(--color-border-focus)",
    "colorBorderSubtle": "var(--color-border-subtle)",
    "colorFeedbackError": "var(--color-feedback-error)",
    "colorFeedbackErrorBg": "var(--color-feedback-error-bg)",
    "colorFeedbackSuccess": "var(--color-feedback-success)",
    "colorFeedbackSuccessBg": "var(--color-feedback-success-bg)",
    "colorFeedbackWarning": "var(--color-feedback-warning)",
    "colorFeedbackWarningBg": "var(--color-feedback-warning-bg)",
    "colorFeedbackInfo": "var(--color-feedback-info)",
    "colorFeedbackInfoBg": "var(--color-feedback-info-bg)",
    "radiusNone": "var(--radius-none)",
    "radiusSm": "var(--radius-sm)",
    "radiusMd": "var(--radius-md)",
    "radiusLg": "var(--radius-lg)",
    "radiusXl": "var(--radius-xl)",
    "radiusXxl": "var(--radius-xxl)",
    "radiusPill": "var(--radius-pill)",
    "radiusCircle": "var(--radius-circle)",
    "shadowNone": "var(--shadow-none)",
    "shadowSm": "var(--shadow-sm)",
    "shadowMd": "var(--shadow-md)",
    "shadowLg": "var(--shadow-lg)",
    "shadowNavigation": "var(--shadow-navigation)",
    "transitionFast": "var(--transition-fast)",
    "transitionDefault": "var(--transition-default)",
    "transitionSlow": "var(--transition-slow)",
    "zBase": "var(--z-base)",
    "zDropdown": "var(--z-dropdown)",
    "zSticky": "var(--z-sticky)",
    "zModal": "var(--z-modal)",
    "zPopover": "var(--z-popover)",
    "zTooltip": "var(--z-tooltip)",
    "zToast": "var(--z-toast)"
  }
} as const;
export type Tokens = typeof tokens;
export default tokens;
